const base = require('base/checkout/address');

/**
 * Populate the Address Summary View
 * @param {string} parentSelector - the top level DOM selector for a unique address summary
 * @param {Object} address - the address data
 */
function populateAddressSummary(parentSelector, address) {
  $.each(address, (attr) => {
    const val = address[attr];

    if (attr === 'countryCode') {
      $('.country', parentSelector).text(`(${address[attr].displayValue})` || '');
    } else if (attr === 'phone') {
      const prefixValue = address.phonePrefix;
      $(`.${attr}`, parentSelector).text(
        val?.includes(prefixValue) ? val : `${prefixValue} ${val}`,
      );
    } else if (attr === 'custom') {
      $.each(val, (customAttr) => {
        $(`.${customAttr}`, parentSelector).text(val[customAttr] || '');
      });
    } else if (attr === 'city') {
      $('.city', parentSelector).text(address.custom?.byl_cityLabel || val);
    } else {
      $(`.${attr}`, parentSelector).text(val || '');
    }
  });
}

/**
 * Updates address selector address option
 * @param {Object} addressData - address data
 * @param {dw.customer.CustomerAddress} addressData.address - Customer address
 * @param {string} addressData.UUID address UUID
 */
function updateAddressOption(addressData) {
  const safeShipping = addressData || {};
  const address = safeShipping.address || {};
  const addressInput = $(`input[value="${addressData.UUID}"]`);

  if (addressInput.length === 0) {
    return;
  }

  // Update label
  const label = addressInput.closest('.address-option').find('label');
  label.empty();
  label.append(`<p class="display-name option-title">${address.title || ''}</p>`);
  label.append(`<p class="option-subtitle">${address.firstName || ''} ${address.lastName || ''}</p>`);
  label.append(`<p class="option-subtitle">${address.address1 || ''} ${address.address2 || ''}</p>`);
  label.append(`<p class="option-subtitle">${address.postalCode || ''}</p>`);
  label.append(`<p class="option-subtitle">${address.custom.byl_cityLabel || address.city || ''} (${address.countryCode.displayValue || ''})</p>`);

  // Update input data attributes
  const keyMap = {
    'data-title': 'title',
    'data-first-name': 'firstName',
    'data-last-name': 'lastName',
    'data-address1': 'address1',
    'data-address2': 'address2',
    'data-city': 'city',
    'data-state-code': 'stateCode',
    'data-colonia': 'byl_colonia',
    'data-comuna-code': 'byl_comuna',
    'data-country-code': 'countryCode',
    'data-postal-code': 'postalCode',
    'data-phone': 'phone',
  };
  $.each(keyMap, (key) => {
    const mappedKey = keyMap[key];
    let mappedValue = address[mappedKey];

    if (mappedKey.indexOf('byl_') === 0) {
      mappedValue = address.custom[mappedKey];
    }

    // In case of country code
    if (mappedValue && typeof mappedValue === 'object') {
      mappedValue = mappedValue.value;
    }

    addressInput.attr(key, mappedValue || '');
  });
}

base.methods.updateAddressOption = updateAddressOption;
base.methods.populateAddressSummary = populateAddressSummary;

module.exports = base;
